<template>
    <PageTemplateContent>
        <BaseHero title="About us" />
        <ContentBlocksText>
            <h2>Background</h2>
            <p>MedPeers is a secure online educational streaming platform intended to teach, coach and upskill medical professionals. MedPeers’ primary intent is to improve healthcare education all over the globe by providing educational video material made by and intended for healthcare professionals in all medical fields from primary to tertiary care.</p>
            <p>Uploaded content will be securely available to medical professionals only, adhering to data protection and privacy legislation in every country and abiding to specific institutional policies. Secondary goals are to support intercollegial collaboration and cross-pollination amongst physicians, to enhance confidence and credibility of medical professionals and increase trust and confidence of patients undergoing medical procedures, to make education available in 3rd world countries, to reduce procedural costs by avoiding a trial-and-error approach and to reduce CO2 emission by reducing the necessity for physicians and industry representatives to travel.</p>
        </ContentBlocksText>
        <BaseSection>
            <template #title>Team</template>
            <div class="team-cards">
                <figure
                    class="team-card"
                    data-span-all
                >
                    <NuxtPicture
                        src="/images/team/meijerink.jpg"
                        alt=""
                        sizes="xs:300px, md:400px"
                        width="300px"
                        height="300px"
                        loading="lazy"
                        decoding="async"
                        :img-attrs="{ fetchpriority: 'low' }"
                    />
                    <figcaption class="team-card__body">
                        <div class="team-card__name">Martijn Meijerink</div>
                        <div class="team-card__function-title">Founder and CEO</div>
                    </figcaption>
                </figure>
                <figure
                    class="team-card"
                    data-span-all
                >
                    <NuxtPicture
                        src="/images/team/puijk.jpg"
                        alt=""
                        sizes="xs:300px, md:400px"
                        width="300px"
                        height="300px"
                        loading="lazy"
                        decoding="async"
                        :img-attrs="{ fetchpriority: 'low' }"
                    />
                    <figcaption class="team-card__body">
                        <div class="team-card__name">Robbert Puijk</div>
                        <div class="team-card__function-title">Chief technology officer</div>
                    </figcaption>
                </figure>
                <figure
                    class="team-card"
                    data-span-all
                >
                    <NuxtPicture
                        src="/images/team/lei.jpg"
                        alt=""
                        sizes="xs:300px, md:400px"
                        width="300px"
                        height="300px"
                        loading="lazy"
                        decoding="async"
                        :img-attrs="{ fetchpriority: 'low' }"
                    />
                    <figcaption class="team-card__body">
                        <div class="team-card__name">Susan van der Lei</div>
                        <div class="team-card__function-title">Chief operating officer</div>
                    </figcaption>
                </figure>
            </div>
        </BaseSection>
        <ContentBlocksText>
            <h2>Get in touch</h2>
            <p>
                We're always interested in feedback, questions and suggestions. Please feel free to contact us.
            </p>
            <p>
                <a href="mailto:support@medpeers.org">support@medpeers.org</a>
            </p>
        </ContentBlocksText>
    </PageTemplateContent>
</template>

<script setup>
const { asset } = useBaseUrl();

useSeoMeta({
    title: 'MedPeers | About us',
    description: 'Educational videos made by peers for medical professionals.',
    ogImage: asset('/images/og/default.png')
});
</script>

<style lang="less" scoped>
.team-cards {
    display: flex;
    gap: 1rem;

    @media @q-md-max {
        flex-direction: column;
    }
}

.team-card {
    flex: 1;
    margin-bottom: 2rem;
    // width: 33%;
    // aspect-ratio: 1/1;

    :deep(picture) {
        width: 100%;
    }

    :deep(img) {
        display: block;
        overflow: hidden;
        border-radius: 10px;
        aspect-ratio: 1/1;
        width: 100%;
        height: auto;
        object-fit: cover;

        @media @q-md-min {
            height: 12.5rem;
        }
    }
}

.team-card__body {
    margin-top: 1rem;

    div {
        margin-bottom: .3125rem;

        &:first-child {
            .typography-h4();
            margin-bottom: .5rem;
        }
    }
}
</style>
